import Loadable from "app/components/Loadable";
import { lazy } from "react";

const UserList = Loadable(lazy(() => import("./UserList")));
const UserForm = Loadable(lazy(() => import("./UserForm")));

const userRoutes = [
  {
    path: "/User/UserList",
    element: <UserList />,
  },
  {
    path: "/User/UserForm",
    element: <UserForm />,
  },
  {
    path: "/User/UserForm/:userId",
    element: <UserForm />,
  },
];
export default userRoutes;
